// extracted by mini-css-extract-plugin
module.exports = {"processMain":"Process_processMain__1WaE7","imageBox":"Process_imageBox__2_5Ya","processBox":"Process_processBox__2U4Jv","smalltext":"Process_smalltext__2CVu3"};